export default {
  short: {},
  large: {},
  contentModuleRow: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  contentModuleCell: {
    display: 'table-cell',
    '&$short': {
      width: '35%'
    },
    '&$large': {
      width: '65%'
    },
  },
  contentModuleCellTitle: {
    font: "500 15px 'Roboto', sans-serif",
  },
  contentModuleCellPrice: {
    font: "500 15px 'Roboto', sans-serif",
    textAlign: 'right',
    '&:lang(ar)': {
      textAlign: "left"
    }
  },
  starDiscount:{
    maxWidth: '140px'
  },
  priceNumbers:{
    font: "300 13px 'Roboto', sans-serif",
    color: '#666',
  },
  loyaltyPrice:{
    color: data => data.STdefaultTier,
  },
  discountPrice:{
    fontWeight: '500',
    fontSize: '15px',
    '&:not($loyaltyPrice)':{
      color: '#5ca70a'
    }
  },
  stDefault: {
    fill: data => data.STdefaultTier,
    color: data => data.STdefaultTier,
    borderColor: data => data.STdefaultTier,
  },
}